import $ from 'jquery'
import Screen from './screen'
import { isActive, isOpen, isShow, breakpointMD } from '../_variables'

export default class NavGlobal {
  init() {
    let dragging = false;
    let event = 'click';
    
    $("body").on("touchmove", function(){
      dragging = true;
    });
    
    $("body").on("touchend", function(){
      if (dragging)
          return;
    
      // wasn't a drag, just a tap
      // more code here
    
    });
    
    $("body").on("touchstart", function(){
      dragging = false;
    });


    $(function () {
      const screen = new Screen()

      $(window).on('breakpointChange', function () {

        if( $(window).innerWidth() > $(window).innerHeight() ) {
          $('html').addClass('landscape');
          $('.c-header').removeClass(isActive)
          $('.header-nav').removeClass(isOpen)
          $('.js-header-menu').removeClass(isShow)
        } else {
          $('html').removeClass('landscape'); 
        }
      })

      $(window).on('resize', function () {
        if (!screen.isPC) {
          let headerHeight = $('.c-header').height();
          let navHeight= 359;
          let winHeight = $(window).height() - headerHeight;

          if(winHeight > navHeight){
            $('.header-nav').css({
              'height': navHeight,
              'padding-bottom': 0
            });
          }else {
            $('.header-nav').css({
              'height': '100%',
              'padding-bottom': headerHeight
            });
          }

          $('.header-nav').css({
            'top': headerHeight, 
          });
          
        } else {
          $('.header-nav').removeAttr('style')
          $('.c-overlay-nav-global').removeClass('-is-active')
          $('.js-header-menu').removeClass(isShow)
          screen.unlock()
        }
      })

      $('.js-header-menu').on('click', function () {
        if (!screen.isPC) {
          let headerHeight = $('.c-header').height();
          let navHeight= 359;
          let winHeight = $(window).height() - headerHeight;

          if(winHeight > navHeight){
            $('.header-nav').css({
              'height': navHeight,
              'padding-bottom': 0
            });
          }else {
            $('.header-nav').css({
              'height': '100%',
              'padding-bottom': headerHeight
            });
          }

          $('.header-nav').css({
            'top': headerHeight
          });
        }

        if (!$(this).hasClass(isShow)) {
          $(this).addClass(isShow)
          $('.header-nav').addClass(isOpen)
          $('.c-header').addClass(isActive)
          $('.js-btn-close').addClass(isShow)

          if ($(window).innerWidth() < breakpointMD) {
            $('.c-overlay-nav-global').addClass('-is-active')
            screen.lock()
          }
        } else {
          $(this).removeClass(isShow)
          $('.header-nav').removeClass(isOpen)
          $('.c-header').removeClass(isActive)
          $('.js-btn-close').removeClass(isShow)

          $('.c-overlay-nav-global').removeClass('-is-active')

          if(!$('body').hasClass('-is-modal-open')) {
            screen.unlock()
          }
        }
      })

      $(document).on('click touchend', function (e) {
        if($(e.target).closest('.c-header').length === 0) {
          if(!dragging){
            if($('.c-overlay-nav-global').hasClass('-is-active')){
              $('.js-header-menu').removeClass(isShow)
              $('.header-nav').removeClass(isOpen)
              $('.c-header').removeClass(isActive)
              $('.c-overlay-nav-global').removeClass('-is-active')
              $('html').removeClass('is-locked').removeAttr('style');
            }
          }
        }

      });
    })
  }
}
